(function () {
  'use strict';
  window.ORCampaignMotionVersion = 'v3';
  function init(scope) {
    scope.querySelectorAll('[data-or-motion]').forEach(function (media) {
      if (media.dataset.motionReady === 'true') return;
      var video = media.querySelector('video');
      var button = media.querySelector('[data-or-motion-toggle]');
      var poster = media.querySelector('[data-or-campaign-poster]');
      if (!video || !button) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var connection = navigator.connection;
      var inView = false, manuallyPaused = false, userStarted = false, loaded = false;
      function automaticAllowed() { return !reduce.matches && !(connection && connection.saveData); }
      function syncButton() {
        button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      }
      function pause() { video.pause(); syncButton(); }
      function loadPoster() {
        var src = video.getAttribute('data-poster');
        if (src && !video.getAttribute('poster')) video.setAttribute('poster', src);
        if (poster && !poster.getAttribute('src') && poster.dataset.src) poster.setAttribute('src', poster.dataset.src);
      }
      function play() {
        loadPoster();
        if (!loaded) {
          var directSource = video.getAttribute('data-or-motion-src');
          if (directSource) {
            video.setAttribute('src', directSource);
          } else {
            video.querySelectorAll('source[data-src]').forEach(function (source) { source.src = source.dataset.src; });
          }
          loaded = true;
          media.dataset.motionSourceReady = video.getAttribute('src') || (video.querySelector('source[src]') && video.querySelector('source[src]').getAttribute('src')) || '';
          video.load();
        }
        video.muted = true;
        video.defaultMuted = true;
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(syncButton);
      }
      function update() {
        if (!inView || document.hidden || manuallyPaused || (!userStarted && !automaticAllowed())) pause();
        else play();
      }
      button.hidden = false;
      syncButton();
      function activate(event) {
        if (event && event.type === 'touchend' && event.cancelable) event.preventDefault();
        media.dataset.motionControlActivated = 'true';
        media.dataset.motionControlEvent = event ? event.type : 'unknown';
        if (!loaded || video.paused) { manuallyPaused = false; userStarted = true; play(); }
        else { manuallyPaused = true; pause(); }
      }
      button.addEventListener('click', activate);
      button.addEventListener('touchend', activate, { passive: false });
      video.addEventListener('playing', function () { media.classList.add('is-playing'); syncButton(); });
      video.addEventListener('pause', syncButton);
      video.addEventListener('error', function () { media.classList.remove('is-playing'); syncButton(); });
      function preferenceChanged() { userStarted = false; update(); }
      if (reduce.addEventListener) reduce.addEventListener('change', preferenceChanged);
      if (connection && connection.addEventListener) connection.addEventListener('change', preferenceChanged);
      document.addEventListener('visibilitychange', update);
      var observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (inView) loadPoster();
          update();
        }, { threshold: 0.1 });
        observer.observe(media);
      } else {
        loadPoster();
      }
      function unload(event) {
        if (!event.target.contains(media)) return;
        pause();
        if (observer) observer.disconnect();
        if (reduce.removeEventListener) reduce.removeEventListener('change', preferenceChanged);
        if (connection && connection.removeEventListener) connection.removeEventListener('change', preferenceChanged);
        document.removeEventListener('visibilitychange', update);
        button.removeEventListener('click', activate);
        button.removeEventListener('touchend', activate);
        document.removeEventListener('shopify:section:unload', unload);
      }
      document.addEventListener('shopify:section:unload', unload);
      media.dataset.motionReady = 'true';
    });
  }
  if (!window.ORCampaignMotionFirstActivationBound) {
    window.ORCampaignMotionFirstActivationBound = true;
    document.addEventListener('click', function (event) {
      var target = event.target;
      var button = target && target.closest ? target.closest('[data-or-motion-toggle]') : null;
      if (!button) return;
      var media = button.closest('[data-or-motion]');
      if (!media) return;
      var video = media.querySelector('video');
      if (!video) return;
      var source = video.querySelector('source[data-src]');
      if (video.getAttribute('src') || (source && source.getAttribute('src'))) return;
      var directSource = video.getAttribute('data-or-motion-src');
      if (directSource) {
        video.setAttribute('src', directSource);
      } else if (source && source.dataset.src) {
        source.setAttribute('src', source.dataset.src);
      } else {
        return;
      }
      media.dataset.motionActivated = 'first-click';
    }, true);
  }

  init(document);
  if (!window.ORCampaignMotionBound) {
    window.ORCampaignMotionBound = true;
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  }
})();

